(function () {
  if (window.SarahHaranKlaviyoEmailFormInitialized) return;

  window.SarahHaranKlaviyoEmailFormInitialized = true;

  var API_REVISION = '2026-01-15';
  var MIN_SUBMIT_DELAY = 3000;

  function parseResponse(response) {
    return response.text().then(function (text) {
      var payload = {};

      if (text) {
        try {
          payload = JSON.parse(text);
        } catch (error) {
          payload = {};
        }
      }

      return {
        ok: response.ok,
        status: response.status,
        payload: payload,
      };
    });
  }

  function getErrorMessage(result, fallback) {
    if (result && result.payload && Array.isArray(result.payload.errors) && result.payload.errors[0]) {
      return result.payload.errors[0].detail || result.payload.errors[0].title || fallback;
    }

    return fallback;
  }

  function setTimestamp(form) {
    var timestampField = form.querySelector('input[name="timestamp"]');

    if (timestampField) {
      timestampField.value = String(Date.now());
    }
  }

  function clearMessages(form) {
    var input = form.querySelector('input[type="email"]');
    var errorMessage = form.querySelector('[data-email-form-error]');
    var successMessage = form.querySelector('[data-email-form-success]');

    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }

    if (errorMessage) {
      errorMessage.classList.add('hidden');
    }

    if (successMessage) {
      successMessage.classList.add('hidden');
    }
  }

  function showError(form, message) {
    var input = form.querySelector('input[type="email"]');
    var errorMessage = form.querySelector('[data-email-form-error]');
    var errorText = form.querySelector('[data-email-form-error-text]');

    if (!errorMessage || !input) return;

    if (errorText) {
      errorText.textContent = message;
    }

    errorMessage.classList.remove('hidden');
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', errorMessage.id);
  }

  function showSuccess(form) {
    var input = form.querySelector('input[type="email"]');
    var errorMessage = form.querySelector('[data-email-form-error]');
    var successMessage = form.querySelector('[data-email-form-success]');

    if (!successMessage) return;

    if (errorMessage) {
      errorMessage.classList.add('hidden');
    }

    if (input) {
      input.removeAttribute('aria-invalid');
      input.setAttribute('aria-describedby', successMessage.id);
    }

    successMessage.classList.remove('hidden');
    successMessage.focus();
  }

  function collectProfileProperties(form) {
    var props = {};
    var fields = form.querySelectorAll('[data-klaviyo-property]');
    fields.forEach(function (field) {
      var key = field.dataset.klaviyoProperty;
      var value = field.value ? field.value.trim() : '';
      if (key && value) props[key] = value;
    });

    var dialCode = form.querySelector('[data-dial-code]');
    var phoneNumber = form.querySelector('[data-phone-number]');
    if (dialCode && phoneNumber && phoneNumber.value.trim()) {
      var number = phoneNumber.value.trim().replace(/^0/, '');
      props.phone_number = dialCode.value + number;
    }

    return props;
  }

  function bindDialCode(form) {
    var dialCode = form.querySelector('[data-dial-code]');
    var countrySelect = form.querySelector('[data-klaviyo-property="country"]');
    if (!dialCode || !countrySelect) return;

    dialCode.addEventListener('change', function () {
      var selectedOption = dialCode.options[dialCode.selectedIndex];
      var country = selectedOption.dataset.country;
      if (!country) return;
      var matchingOption = Array.prototype.find.call(countrySelect.options, function (opt) {
        return opt.value === country;
      });
      if (matchingOption) countrySelect.value = country;
    });
  }

  function updateProfile(form, email, campaignId, extraProps) {
    var properties = Object.assign({}, extraProps || {});
    if (campaignId) properties.shopify_campaign = campaignId;

    var firstName = form.querySelector('[data-klaviyo-first-name]');
    var lastName = form.querySelector('[data-klaviyo-last-name]');
    var firstNameValue = firstName && firstName.value.trim();
    var lastNameValue = lastName && lastName.value.trim();

    if (Object.keys(properties).length === 0 && !firstNameValue && !lastNameValue) {
      return Promise.resolve();
    }

    var payload = { email: email, properties: properties };
    if (firstNameValue) payload.first_name = firstNameValue;
    if (lastNameValue) payload.last_name = lastNameValue;

    return fetch('https://sarah-haran-klaviyo-profile-proxy.luc-8bb.workers.dev', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).then(parseResponse).then(function (result) {
      if (!result.ok) {
        return Promise.reject(getErrorMessage(result, form.dataset.klaviyoDefaultError));
      }

      return result;
    });
  }

  function subscribeProfile(form, email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.klaviyoPublicKey), {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: API_REVISION,
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: form.dataset.klaviyoListId,
              },
            },
          },
        },
      }),
    }).then(parseResponse).then(function (result) {
      if (!result.ok) {
        return Promise.reject(getErrorMessage(result, form.dataset.klaviyoDefaultError));
      }

      return result;
    });
  }

  function bindForm(form) {
    if (!form || form.dataset.klaviyoReady === 'true') return;

    form.dataset.klaviyoReady = 'true';
    setTimestamp(form);
    bindDialCode(form);

    form.addEventListener('submit', function (event) {
      var input = form.querySelector('input[type="email"]');
      var honeypot = form.querySelector('input[name="subscriber_name"]');
      var timestampField = form.querySelector('input[name="timestamp"]');
      var submitButton = form.querySelector('button[type="submit"]');
      var fallbackError = form.dataset.klaviyoDefaultError || 'Something went wrong. Please try again.';
      var submittedAt = timestampField ? parseInt(timestampField.value, 10) : 0;

      if (!input || !input.reportValidity()) {
        return;
      }

      event.preventDefault();
      clearMessages(form);

      if (honeypot && honeypot.value !== '') {
        showError(form, fallbackError);
        return;
      }

      if (submittedAt && Date.now() - submittedAt < MIN_SUBMIT_DELAY) {
        showError(form, fallbackError);
        return;
      }

      submitButton.disabled = true;

      var extraProps = collectProfileProperties(form);

      subscribeProfile(form, input.value.trim())
        .then(function () {
          return updateProfile(form, input.value.trim(), form.dataset.klaviyoCampaignId, extraProps);
        })
        .then(function () {
          form.reset();
          setTimestamp(form);
          showSuccess(form);
        })
        .catch(function (message) {
          showError(form, message || fallbackError);
        })
        .finally(function () {
          submitButton.disabled = false;
        });
    });
  }

  function init(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('[data-klaviyo-email-form]');

    forms.forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();